<template>
    <div id="app">
      <v-toolbar class="main mb-0">
        <button class="nav-back" @click="goBack">&lt; Tillbaka</button>
      </v-toolbar>
      <h2 v-if="!this.$store.state.isDistributor" class="mb-2 text-overflow">Signera som {{this.$store.state.transaction.signed}}</small></h2>
      <h2 v-if="this.$store.state.isDistributor" class="mb-2 text-overflow">Signera som {{this.$store.state.distributorTransaction.signed}}</small></h2>
      <vueSignature class="signature mb-3" ref="signature" :sigOption="option" :w="'340px'" :h="'350px'"></vueSignature>
      <v-layout row>
        <v-flex xs4 class="pr-2">
          <v-btn color="secondary" block @click="clear">Sudda</v-btn>
        </v-flex>
        <v-flex xs8>
          <v-btn color="primary" block @click="save">Spara</v-btn>
        </v-flex>
      </v-layout>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: "app",
    data() {
        return {
            option:{
                penColor:"rgb(0, 0, 0)"
            }
        };
    },
    methods:{
        save(){
            var _this = this;
            //var png = _this.$refs.signature.save()
            //var jpeg = _this.$refs.signature.save('image/jpeg')
            var svg = _this.$refs.signature.save('image/svg+xml');
            //console.log(png);
            //console.log(jpeg)
            //console.log(svg)
            this.$store.commit('setSignature', svg);
            //console.log(_this.$store.state.transaction.signature);
            this.$router.push('Review');
        },
        clear(){
            var _this = this;
            _this.$refs.signature.clear();
        },
        goBack(){
            if((this.$store.state.activeProfile.role == "warehouse" || this.$store.state.activeProfile.role == "hybrid-warehouse")  && this.$store.state.isDistributor){
                console.log(this.$store.state.activeProfile.role + " " + this.$store.state.isDistributor);
                this.$router.push('Distributor_Delivery');
            } else if ((this.$store.state.activeProfile.role == "warehouse" || this.$store.state.activeProfile.role == "hybrid-warehouse") && !this.$store.state.isDistributor) {
                console.log(" elseif" + this.$store.state.activeProfile.role + " " + this.$store.state.isDistributor);

                this.$router.push('Delivery_Details');
            } else {
                console.log("else " + this.$store.state.activeProfile.role + " " + this.$store.state.isDistributor);

                this.$router.push('CheckInOut');
            }
        }
    },
    created: function() {

        console.log("Name: ",this.$store.state.transaction.signed);
        this.$store.state.snackbarTrigger = false;
        if(this.$store.state.auth.token == null || this.$store.state.auth.token == ""){
            console.log("Profile Error: Please Login");
            this.$router.push('/');
        }

        if (this.$store.state.activeProfile.role == "driver" || this.$store.state.activeProfile.role == "hybrid-driver") {
            if (this.$store.state.transaction.signed == null) {
                console.log("Transaction Error: Transaction Aborted");
                this.$router.push('/Driver_Home');
            }

            if(this.$store.state.activeCustomer === null || this.$store.state.activeCustomer.name === "" || this.$store.state.activeCustomer === {} || this.$store.state.activeCustomer.address == ""){
                console.log("Customer Error: Please Select Customer")
                this.$router.push('/Driver_Home');
            }
        }

        if (this.$store.state.activeProfile.role == "warehouse" || this.$store.state.activeProfile.role == "hybrid-warehouse") {
            if (this.$store.state.isDistributor) {
                // Validation for distributor(supplier) transaction
                if (this.$store.state.distributorTransaction.signed == null || this.$store.state.distributorTransaction.signed == "") {
                    console.log("Transaction Error: Transaction Aborted");
                    this.$router.push('/Warehouse_Home');
                }

            } else {
                // Validation for Standard deliveries
                if (this.$store.state.deliveryTransaction.tour_id == null || this.$store.state.deliveryTransaction.tour_id == "") {
                    console.log("Transaction Error: Transaction Aborted");
                    this.$router.push('/Warehouse_Home');
                }

            }
        }

    }
};
</script>

<style>

    .text-overflow {
        width: 295px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

</style>



// WEBPACK FOOTER //
// src/components/Signature.vue